<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Add Production Devices</span>
    </div>
  </div>

  @if (isUploadBoxVisible) {
    <div class="component-container">
      <form [formGroup]="addProductionDeviceForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">Production Devices</h6>
          <div class="component-actions">
            <button
              class="primary-button"
              type="button"
              (click)="downloadMyFile()"
            >
              Download Sample<mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="file" class="form-label"
                >Upload Production Device File</label
              >
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Upload Production Device File</mat-label>

                <!-- Display File Name or Placeholder -->
                <input matInput type="text" formControlName="file" readonly />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                @if (
                  addProductionDeviceForm.controls['file'].touched &&
                  addProductionDeviceForm.controls['file'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button
              class="submit-button"
              (click)="saveDeviceDetails()"
              [disabled]="!fileUploaded"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  }

  @if (!isUploadBoxVisible) {
    <!-- Uploaded Production Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Uploaded Production Device List</h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="productionUploadedDeviceList.length === 0"
              (click)="
                exportToExcelUploadedProducedDeviceData(
                  productionUploadedDeviceList
                )
              "
              value="excel"
            >
              Export Uploaded Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Device IMEI</th>
              <th>Device UID</th>
              <th>Device ICCID</th>
              <th>Device Model Name</th>
              <th>Remark</th>
            </tr>
          </thead>
          @if (productionUploadedDeviceList.length > 0) {
            <tbody>
              @for (
                item of productionUploadedDeviceList
                  | paginate
                    : {
                        id: 'paginateUpload',
                        itemsPerPage: productionUploadedDeviceSize,
                        currentPage: productionUploadedDevicePage,
                        totalItems: productionUploadedDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.imei }}</td>
                  <td>{{ item.uid }}</td>
                  <td>{{ item.iccid }}</td>
                  <td>{{ item.modelName }}</td>
                  <td>{{ item.result }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (productionUploadedDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="productionUploadedDeviceList.length"
            [pageSize]="productionUploadedDeviceSize"
            [currentPage]="productionUploadedDevicePage"
            (pageChange)="onPageChangeproductionUploadedDeviceList($event)"
            (sizeChange)="onSizeChangeproductionUploadedDeviceList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Duplicate Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Duplicate Device List</h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="productionDuplicateDeviceList.length === 0"
              (click)="
                exportToExcelDuplicateProducedDeviceData(
                  productionDuplicateDeviceList
                )
              "
              value="excel"
            >
              Export Duplicate Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Device IMEI</th>
              <th>Device UID</th>
              <th>Device ICCID</th>
              <th>Device Model Name</th>
              <th>Remark</th>
            </tr>
          </thead>
          @if (productionDuplicateDeviceList.length > 0) {
            <tbody>
              @for (
                item of productionDuplicateDeviceList
                  | paginate
                    : {
                        id: 'batchPaginateproductionDuplicateDeviceList',
                        itemsPerPage: productionDuplicateDeviceSize,
                        currentPage: productionDuplicateDevicePage,
                        totalItems: productionDuplicateDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.imei }}</td>
                  <td>{{ item.uid }}</td>
                  <td>{{ item.iccid }}</td>
                  <td>{{ item.modelName }}</td>
                  <td>{{ item.result }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (productionDuplicateDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="productionDuplicateDeviceList.length"
            [pageSize]="productionDuplicateDeviceSize"
            [currentPage]="productionDuplicateDevicePage"
            (pageChange)="onPageChangeproductionDuplicateDeviceList($event)"
            (sizeChange)="onSizeChangeproductionDuplicateDeviceList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Invalid Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Invalid Device List</h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="productionInvalidDeviceList.length === 0"
              (click)="
                exportToExcelInvalidProducedDeviceData(
                  productionInvalidDeviceList
                )
              "
              value="excel"
            >
              Export Invalid Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Device IMEI</th>
              <th>Device UID</th>
              <th>Device ICCID</th>
              <th>Device Model Name</th>
              <th>Remark</th>
            </tr>
          </thead>
          @if (productionInvalidDeviceList.length > 0) {
            <tbody>
              @for (
                item of productionInvalidDeviceList
                  | paginate
                    : {
                        id: 'paginateInvalid',
                        itemsPerPage: productionInvalidDeviceSize,
                        currentPage: productionInvalidDevicePage,
                        totalItems: productionInvalidDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.imei }}</td>
                  <td>{{ item.uid }}</td>
                  <td>{{ item.iccid }}</td>
                  <td>{{ item.modelName }}</td>
                  <td>{{ item.result }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (productionInvalidDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="productionInvalidDeviceList.length"
            [pageSize]="productionInvalidDeviceSize"
            [currentPage]="productionInvalidDevicePage"
            (pageChange)="onPageChangeproductionInvalidDeviceList($event)"
            (sizeChange)="onSizeChangeproductionInvalidDeviceList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
